import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/integration/[name]/PageContent.tsx");
